// extracted by mini-css-extract-plugin
export default {"products":"RecipeProducts_products__6sLXK","icon":"RecipeProducts_icon__1dVjk","list":"RecipeProducts_list__1lYWy","ul":"RecipeProducts_ul__4fcWO"};